
const RegisterHtmlTemplate = require('polymer-webpack-loader/register-html-template');

RegisterHtmlTemplate.register("<dom-module id=cdiv-header> <template> <style include=shared-style></style> <style>" + require("./cdiv-header.css") + "</style> <a dom-scope=u5e27d4L id=abc-logo-link> <aofl-picture id=abc-logo> <aofl-img aofl-src=" + require("./images/abc_logo.png") + "></aofl-img> </aofl-picture> </a> <div class=side-container> <slot name=right></slot> </div> <aofl-img class=z-context-5 aofl-src=" + require("./images/child_safe.png") + " id=child-safe></aofl-img> </template> </dom-module>");

require('./cdiv-header.js');



// WEBPACK FOOTER //
// ./cdiv/en-US/js/cdiv-header/cdiv-header.html